import React, { useMemo, memo } from 'react';
import { CircleCheck } from 'lucide-react';
import Button from '../common/button/Button';

import styles from './styles/SubscriptionPlans.module.css';

const PricingCard = ({
    plan,
    isCurrentPlan,
    onSubscribe,
    buttonText = 'Subscribe',
    buttonLink = null,
    showCurrentPlan = true,
}) => {
    const buttonContent = useMemo(() => {
        return showCurrentPlan && isCurrentPlan ? 'Subscribed' : buttonText;
    }, [showCurrentPlan, isCurrentPlan, buttonText]);

    return (
        <div className={`${styles.card} ${styles.planCard}`}>
            <div className={styles.planHeader}>
                <h3>{plan.name}</h3>
                <span className={styles.price}>
                    <span className={styles.priceValue}>${plan.price}</span>
                    <span className={styles.priceDuration}>/month</span>
                </span>
            </div>
            <Button
                href={buttonLink}
                onClick={buttonLink ? undefined : () => onSubscribe(plan.id)}
                disabled={!buttonLink && showCurrentPlan && isCurrentPlan}
                size="large"
                className={styles.fullWidth}
            >
                {buttonContent}
            </Button>
            <div className={styles.planFeatures}>
                <div className={styles.planFeature}>
                    <CircleCheck size={12} />
                    <span>{plan.credits.toLocaleString()} subscription credits per month</span>
                </div>
                {plan.name !== 'free' && (
                    <div className={styles.planFeature}>
                        <CircleCheck size={12} />
                        <span>Access to purchased credits</span>
                    </div>
                )}
                {plan.name !== 'free' && (
                    <div className={styles.planFeature}>
                        <CircleCheck size={12} />
                        <span>Access to all features</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default memo(PricingCard);
